<template>
  <div v-loading.fullscreen.lock="loading">
    <travel-address-search-bar-component
      add_auth="新增差旅目的地"
      @search="get_travel_address_index"
      @addTeam="addTeam"
    ></travel-address-search-bar-component>
    <common-table-component
      details_auth="差旅目的地详情"
      :col_arr="fcol_arr"
      :table_data="ftable_data"
      @details_row="details_travel_address"
    ></common-table-component>
    <common-page-component
      :current_page="cond.page"
      :page_size="cond.limit"
      :total="ftotal"
      @search="get_travel_address_index"
    ></common-page-component>
    <travel-address-edit-component
      edit_auth="修改差旅目的地"
      del_auth="删除差旅目的地"
      :id="fid"
      :show_type="edit_type"
      :dialogFormVisible="fdialogFormVisible"
      :travel_address_details_data="ftravel_address_details_data"
      @exitTravelAddressDialog="dialogExit"
      @search="get_travel_address_index"
      @show_edit="show_edit"
      @details_row="details_travel_address"
    ></travel-address-edit-component>
  </div>
</template>

<script>
import {
  travel_address_index_request,
  travel_address_details_request,
} from "@/network/finance/TravelAddress.js";

import TravelAddressSearchBarComponent from "@/components/finance/TravelAddress/TravelAddressSearchBarComponent";
import CommonTableComponent from "@/components/common/CommonTableComponent";
import CommonPageComponent from "@/components/common/CommonPageComponent";
import TravelAddressEditComponent from "@/components/finance/TravelAddress/TravelAddressEditComponent";

export default {
  name: "TravelAddressView",
  data() {
    return {
      fid: 0,
      edit_type: 0,
      fdialogFormVisible: false,
      loading: false,
      ftotal: 0,
      cond: {
        name: "",
        page: 1,
        limit: 10,
      },
      ftable_data: [],
      fcol_arr: [
        {
          prop: "name",
          label: "地址名称",
          minWidth: "80px",
        },
        {
          prop: "create_staff_name",
          label: "创建人",
          minWidth: "80px",
        },
        {
          prop: "create_time",
          label: "创建时间",
          minWidth: "200px",
        }
      ],
      ftravel_address_details_data: {},
    };
  },
  computed: {},
  methods: {
    // 添加信息（弹框）
    addTeam() {
      this.edit_type = 1;
      this.fdialogFormVisible = true;
    },
    // 修改（弹框）
    show_edit() {
      this.edit_type = 2;
    },
    get_travel_address_index(param = {}) {
      this.loading = true;
      this.cond.name = param.name ?? this.cond.name;
      this.cond.page = param.page ?? this.cond.page;
      if (param.limit) {
        this.cond.limit = param.limit;
        this.cond.page = 1;
      }
      travel_address_index_request(this.cond)
        .then((s) => {
          this.loading = false;
          if (s.status === 0) {
            this.ftable_data = s.result.data;
            this.ftotal = s.result.total;
          } else {
            this.$message.error(s.msg);
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error(err);
        });
    },
    details_travel_address(id) {
      this.fid = id;
      this.fdialogFormVisible = true;
      travel_address_details_request(id)
        .then((s) => {
          if (s.status === 0) {
            this.ftravel_address_details_data = s.result;
          } else {
            this.$message.error(s.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    dialogExit() {
      this.fdialogFormVisible = false;
      this.fid = 0;
      this.edit_type = 0;
    },
  },
  filters: {},
  props: {},
  created() {
    this.get_travel_address_index();
  },
  destoryed() {},
  mounted() {},
  updated() {},
  components: {
    TravelAddressSearchBarComponent,
    CommonTableComponent,
    CommonPageComponent,
    TravelAddressEditComponent,
  },
  watch: {},
};
</script>

<style lang="less"></style>
